import i18n from '@/lang/i18n'

export default [
  {
    path: '/admin/apply/message/center',
    name: 'messageCenter',
    component: () => import('@/views/message/center'),
    meta: {
      title: i18n.t('router.message.message_center'),
      headType: 0,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/message.js